import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { FRONTEND_ROOT } from "../../../config/constants";
import styles from "./Headline.css";

export default function Headline({ headline, permalink, noLink }) {
  if (headline && permalink && !noLink) {
    return <Link to={permalink.replace(FRONTEND_ROOT, "")} className={styles.headline}><h3>{headline}</h3></Link>;
  } else if (headline) {
    return <h3 className={styles.headline}>{headline}</h3>;
  } else {
    return null;
  }
}

Headline.propTypes = {
  headline: PropTypes.string.isRequired,
  permalink: PropTypes.string,
  noLink: PropTypes.bool,
};
